import {
  initializeFirestore,
  getFirestore,
  collectionGroup,
  collection,
  addDoc,
  getDoc,
  getDocs,
  setDoc,
  doc,
  updateDoc,
  arrayRemove,
  arrayUnion,
  increment,
  deleteDoc,
  deleteField,
  query,
  where,
  onSnapshot,
  orderBy,
  limit,
  startAfter,
  startAt,
  FieldPath
} from "firebase/firestore";

import { firebaseApp } from "./index";

initializeFirestore(firebaseApp, { ignoreUndefinedProperties: true });

const db = getFirestore();

class firestoreClass {
  collection(collectionPath) {
    return new this._collection(collectionPath);
  }
  _collection = class Collection {
    constructor(collectionPath) {
      this.collection = collection(db, collectionPath);

      return this;
    }
    add(data) {
      return addDoc(this.collection, data);
    }
    get() {
      return getDocs(this.collection);
    }
    query(options) {
      const clauses = [];

      if (options.where) {
        for (const [field, operator, value] of options.where) {
          clauses.push(where(field, operator, value));
        }
      }
      if (options.limit) {
        clauses.push(limit(options.limit));
      }
      if (options.orderBy) {
        for (const [field, direction] of options.orderBy) {
          clauses.push(orderBy(field, direction));
        }
      }
      if (options.startAfter) {
        clauses.push(startAfter(options.startAfter));
      }
      if (options.startAt) {
        clauses.push(startAt(options.startAt));
      }

      this.collection = query(this.collection, ...clauses);
      delete this.add;
      return this;
    }
    watch(callback) {
      return onSnapshot(this.collection, callback);
    }
  };
  collectionGroup(collectionPath) {
    return new this._collectionGroup(collectionPath);
  }
  _collectionGroup = class CollectionGroup extends this._collection {
    constructor(collectionGroupPath) {
      super(collectionGroupPath);
      this.collection = collectionGroup(db, collectionGroupPath);

      return this;
    }
  };
  doc(collectionPath, docId) {
    return new this._doc(collectionPath, docId);
  }
  _doc = class Doc {
    constructor(collectionPath, docId) {
      this.doc = doc(db, collectionPath, docId);

      return this;
    }
    get() {
      return getDoc(this.doc);
    }
    update(data) {
      return updateDoc(this.doc, data);
    }
    set(data, merge = true) {
      return setDoc(this.doc, data, { merge });
    }
    delete() {
      return deleteDoc(this.doc);
    }
    watch(callback) {
      return onSnapshot(this.doc, callback);
    }
  };
  // firestore
  FieldPath = (...path) => new FieldPath(...path);
  arrayRemove = arrayRemove;
  arrayUnion = arrayUnion;
  increment = increment;
  deleteField = deleteField;
}

export const firestore = new firestoreClass();
